import React, { useState } from "react";
import CustomNavbar from "../CustomNavbar";
import SRVMarketplaceOverview from "./srvMarketplaceOverview";
import SRVMyListings from "./srvMyListings";
import SRVMyOfferCards from "./srvMyOfferCards";
import SRVCreateListing from "./srvCreateListingSwapWorkAssignment";

const TABS = [
  { key: "markt",     label: "Markt",               short: "Markt" },
  { key: "meine",     label: "Meine Angebote",       short: "Meine Angebote" },
  { key: "angebote",  label: "Meine Gegenangebote",  short: "Gegenangebote" },
  { key: "erstellen", label: "+ Angebot erstellen",  short: "+ Erstellen" },
];

const SwapBoerse = () => {
  const [activeTab, setActiveTab] = useState("markt");

  return (
    <div className="bg-dark min-vh-100 text-white">
      <CustomNavbar />

      <div className="container mt-4 pb-5">
        <header className="mb-4">
          <h1 className="mb-1">Tauschbörse</h1>
          <p className="text-white-50 mb-0">
            Biete Arbeitseinsätze zum Tausch an oder nimm Gegenangebote an.
          </p>
        </header>

        {/* Mobil: scrollbare Pill-Buttons */}
        <div
          className="d-md-none mb-4"
          style={{
            display: "flex",
            overflowX: "auto",
            gap: 8,
            paddingBottom: 4,
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          {TABS.map((tab) => {
            const active = activeTab === tab.key;
            return (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                style={{
                  flexShrink: 0,
                  padding: "9px 18px",
                  borderRadius: 999,
                  border: active ? "2px solid #facc15" : "2px solid rgba(255,255,255,0.2)",
                  background: active ? "#facc15" : "rgba(255,255,255,0.06)",
                  color: active ? "#111" : "rgba(255,255,255,0.75)",
                  fontWeight: active ? 700 : 500,
                  fontSize: 14,
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  transition: "background .15s, color .15s, border-color .15s",
                }}
              >
                {tab.short}
              </button>
            );
          })}
        </div>

        {/* Desktop: Tab-Leiste */}
        <ul
          className="d-none d-md-flex nav mb-4"
          style={{ borderBottom: "1px solid rgba(255,255,255,0.15)", gap: 4 }}
        >
          {TABS.map((tab) => {
            const active = activeTab === tab.key;
            return (
              <li className="nav-item" key={tab.key}>
                <button
                  className="nav-link"
                  onClick={() => setActiveTab(tab.key)}
                  style={{
                    color: active ? "#facc15" : "rgba(255,255,255,0.6)",
                    background: "none",
                    border: "none",
                    borderBottom: active ? "2px solid #facc15" : "2px solid transparent",
                    borderRadius: 0,
                    fontWeight: active ? 700 : 400,
                    padding: "8px 16px",
                    cursor: "pointer",
                    transition: "color .15s, border-color .15s",
                    whiteSpace: "nowrap",
                  }}
                >
                  {tab.label}
                </button>
              </li>
            );
          })}
        </ul>

        {/* Tab-Inhalte */}
        {activeTab === "markt"     && <SRVMarketplaceOverview />}
        {activeTab === "meine"     && (
          <SRVMyListings onCreateNew={() => setActiveTab("erstellen")} />
        )}
        {activeTab === "angebote"  && <SRVMyOfferCards />}
        {activeTab === "erstellen" && (
          <SRVCreateListing onCreated={() => setActiveTab("meine")} />
        )}
      </div>
    </div>
  );
};

export default SwapBoerse;
